import { create } from "zustand";
import { persist, devtools } from "zustand/middleware";
import { DictType, Group, MainTab, SubTab } from "@pma/types";
import { APP_CONFIG } from "@pma/utils/constants";

export type AuthState = {
  authConfig: {
    [x: string]: any;
  };
  [x: string]: any;
};

type TabGroup = "project-detail" | "settings" | "boq" | "main-boq" | "contractor";

export type AuthActions = {
  signIn: (authInfo: DictType) => void;
  signOut: () => void;
  setTabManager: ({
    group,
    main,
    sub,
    subChild,
  }: {
    group: TabGroup;
    main: MainTab;
    sub: SubTab;
    subChild?: string | undefined;
  }) => void;
};

export type AuthStore = AuthState & AuthActions;

export const defaultInitState: AuthState = {
  authConfig: {},
};

export const useAuth = create<AuthStore>()(
  devtools(
    persist(
      (set, get) => ({
        authConfig: { ...defaultInitState?.authConfig },
        signIn: (data: DictType) => {
          set({
            authConfig: { ...get().authConfig, ...data },
          });
        },
        signOut: () => {
          set({
            authConfig: { ...defaultInitState.authConfig },
          });
        },
        setTabManager: ({
          group,
          main,
          sub,
          subChild,
        }: {
          group: Group;
          main: MainTab;
          sub: SubTab;
          subChild?: string | undefined;
        }) => {
          set({
            authConfig: {
              ...get().authConfig,
              tabs: {
                ...get().authConfig?.tabs,
                [group]: {
                  main,
                  sub,
                  subChild,
                },
              },
            },
          });
        },

        setActiveFolder: (folder: DictType) => {
          set({
            authConfig: { ...get().authConfig, activeFolder: folder },
          });
        },

        setProjectFinancial: ({ estimate, main, projectId }: DictType) => {
          set({
            authConfig: {
              ...get().authConfig,
              financial: {
                ...get().authConfig?.financial,
                estimate,
                main,
                projectId,
              },
            },
          });
        },
      }),

      {
        name: APP_CONFIG,
        onRehydrateStorage: (state) => {
          if (state) {
            state.hydrated = true;
          }
        },
      },
    ),
  ),
);
